import { render, staticRenderFns } from "./AdministratorDetail.vue?vue&type=template&id=017b67cb"
import script from "./AdministratorDetail.vue?vue&type=script&lang=js"
export * from "./AdministratorDetail.vue?vue&type=script&lang=js"
import style0 from "./AdministratorDetail.vue?vue&type=style&index=0&id=017b67cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports